import { render, staticRenderFns } from "./AccessUserListItem.vue?vue&type=template&id=220b4248&"
import script from "./AccessUserListItem.vue?vue&type=script&lang=js&"
export * from "./AccessUserListItem.vue?vue&type=script&lang=js&"
import style0 from "./AccessUserListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports